module.exports = __webpack_public_path__ + "img/logo.0aae1c11.svg";